import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api-types'

// seo-wix-code-sdk has no site config data, only shouldLoad logic
// The actual SEO config is provided via page config (which delegates to feature-seo)
const seoWixCodeSdkSiteConfig: SiteConfigFn<never> = ({ api }) => {
	const hasPlatform = api.features.isActive('platform')

	return {
		shouldLoadSiteFeature: hasPlatform,
		shouldLoadSiteConfig: false,
		siteConfig: null,
	}
}

const name = 'seoWixCodeSdk'

export const config = { site: seoWixCodeSdkSiteConfig, name }
